import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import * as Sentry from '@sentry/browser';
import './index.css';
import App from './App';
import reducers from './reducers';
const prod = (process.env.REACT_APP_SUPPLY_DROP_ENVIRONMENT === 'production');

if(prod) Sentry.init({dsn: "https://c94f0f12556e4737935e3a868d54c099@o371167.ingest.sentry.io/5219540"});

const store = createStore(reducers, {}, applyMiddleware(reduxThunk));

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>, 
    document.getElementById('root')
);
